import React from 'react';
import PhoneInput from 'react-phone-number-input'
import { Label } from '@progress/kendo-react-labels'
import "./phone-input-HL-pure.css";

const PhoneInputHLPure = (props) => {
    let {
        labelInput,
        value,
        placeholder,
        onCellphoneChange,
        defaultCountry,
        international,
        countryCallingCodeEditable
    } = props

    return (
        <div className="phoneInputHLPure-container">
            <Label className="phoneInputHLPure-label" >{labelInput}</Label>
            <PhoneInput
                {...props}
                placeholder={placeholder}
                value={value}
                onChange={onCellphoneChange}
                defaultCountry={defaultCountry}
                international={international}
                countryCallingCodeEditable={countryCallingCodeEditable}
            />
        </div>
    )
}

export { PhoneInputHLPure as default }